import ko from './ko';
import en from './en';

type language = {
  [locale: string]: {
    [key: string]: string;
  };
};
export const language: language = { 'ko-KR': ko, 'en-US': en };
